module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/core-js/json/stringify.js
// module id = 33
// module chunks = 0